import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const HistoryPage = lazy(() =>
  import("@/admin/pages/HistoryPage").then((m) => ({ default: m.HistoryPage })),
);

export const Route = createFileRoute("/admin/history")({
  component: () => (
    <Suspense fallback={null}>
      <HistoryPage />
    </Suspense>
  ),
});
